export const CDN_URL = process.env.CDN_URL

export function idToPath (id) {
  var parts = id.split('-')
  return parts[1]
    ? parts[0].substring(0, 2) + '/' + parts[1].substring(0, 2) + '/' + id
    : id
}

export function pickCdnServer (cdnUrl, id) {
  const matches = /^(.+?)-(.+?)-(.+)$/.exec(id)
  if (!matches) {
    return cdnUrl
  }
  const server = matches[3]
  return server && server === 'A'
    ? cdnUrl.replace('cdn', 'cdn' + server)
    : cdnUrl
}

export function getDataUrl (cdnUrl, type, id, postfix) {
  cdnUrl = pickCdnServer(cdnUrl, id)
  const base = `${cdnUrl}/data/${type}/${idToPath(id)}`
  return postfix ? `${base}${postfix}` : base
}

export function getPolyUrl (cdnUrl, type, id) {
  cdnUrl = pickCdnServer(cdnUrl, id)
  return getDataUrl(cdnUrl, type, id, '.poly.json')
}

export function getGraphUrl (cdnUrl, type, id) {
  cdnUrl = pickCdnServer(cdnUrl, id)
  return getDataUrl(
    cdnUrl,
    type === 'videotrack' ? 'track' : type,
    id,
    '.graph.json'
  )
}

export function getVideoUrl (cdnUrl, id, resolution) {
  cdnUrl = pickCdnServer(cdnUrl, id)
  return getDataUrl(cdnUrl, 'video', id, `_${resolution || 's'}.mp4`)
}

export function getPreviewUrlBase (cdnUrl, type, id) {
  cdnUrl = pickCdnServer(cdnUrl, id)
  return `${cdnUrl}/preview/${type}/${idToPath(id)}`
}

export function getPreviewUrl (cdnUrl, type, id) {
  if (type === 'video') {
    return getVideoThumbnailUrl(cdnUrl, id, 0)
  }
  if (type === 'videotrack') {
    type = 'track'
  }
  return getPreviewUrlBase(cdnUrl, type, id)
}

export function getVideoThumbnailUrl (cdnUrl, id, index) {
  index = ('00000000' + (index || 1)).slice(-8)
  return `${getPreviewUrlBase(cdnUrl, 'video', id)}/${index}.jpg`
}

export function getActivityUrl (cdnUrl, subject = 'user', id) {
  cdnUrl = pickCdnServer(cdnUrl, id)
  return `${cdnUrl}/data/activity/${subject}/${id}`
}



// WEBPACK FOOTER //
// ./src/utils/cdn.js